/* eslint-disable jsx-a11y/anchor-is-valid */
import {AnnouncementModel} from 'app/models/AnnouncementModels'
import {NotificationModel} from 'app/models/NotificationModels'
import {useAuth} from 'app/modules/auth'
import {GetAnnouncementDisplayList, GetAnnouncementList} from 'app/services/announcementsService'
import {GetNotificationList, MarkAsRead} from 'app/services/notificationsService'
import {ErrorHandler} from 'app/shared/Alfacom/ErrorHandler/ErrorHandler'
import Iconize from 'app/shared/Alfacom/Icon/Iconize'
import Loading from 'app/shared/Alfacom/Loading/Loading'
import Placeholderize from 'app/shared/Alfacom/Placeholder/Placeholderize'
import {EVENT_EMITTER} from 'app/shared/Common/Constants'
import {GetModuleColor, GetModuleIcon, GetNotificationColor, GetNotificationTypeIcon, Module, NotificationType} from 'app/shared/Common/Enums'
import clsx from 'clsx'
import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {Badge, Modal} from 'react-bootstrap'
import {useBus} from 'react-bus'
import {useCookies} from 'react-cookie'
import {useLocation, useNavigate} from 'react-router-dom'
import {ID, KTSVG, toAbsoluteUrl} from '../../../helpers'

const HeaderNotificationsMenu: FC = () => {
  //#region const Variables
  const {currentUser} = useAuth()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isNotifyLoading, setIsNotifyLoading] = useState<boolean>(false)
  const [checked, setIsChecked] = useState<boolean>(false)
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [announcementList, setAnnouncementList] = useState<AnnouncementModel[]>([])
  const [announcementDisplayList, setAnnouncementDisplayList] = useState<AnnouncementModel[]>([])
  const [activeList, setActiveList] = useState<ID[]>([])
  const [selectedActiveAnnouncementID, setSelectedActiveAnnouncementID] = useState<ID>()
  const [selectedAnnouncement, setSelectedAnnouncement] = useState<AnnouncementModel>()
  const [cookies, setCookie, removeCookie] = useCookies()

  const [loadMore, setLoadMore] = useState<boolean>(true)
  const [page, setPage] = useState(2)
  const [itemPerPage, setItemPerPage] = useState<number>(5)

  const [notificationList, setNotificationList] = useState<NotificationModel[]>([])
  const [showMore, setShowMore] = useState<boolean>(true)
  const [notifyPage, setNotifyPage] = useState(1)
  const [unreadNotificationCount, setUnreadNotificationCount] = useState<number>(0)
  const [refreshInterval, setRefreshInterval] = useState<number>(0)

  const today = new Date()
  const navigate = useNavigate()
  const Bus = useBus()
  const state: any = useLocation().state

  //use for create cookie
  const saveCookie = (announceInfo: AnnouncementModel) => {
    var currentCookie = cookies[`AnnouncementId_${currentUser?.id}`]

    if (currentCookie == undefined) setCookie(`AnnouncementId_${currentUser?.id}`, [announceInfo.AnnouncementId], undefined)
    else {
      setCookie(`AnnouncementId_${currentUser?.id}`, [...currentCookie, announceInfo.AnnouncementId], undefined)
    }

    // removeCookie("AnnouncementId")
  }

  const handleLoadMore = () => {
    setIsLoading(true)
    GetAnnouncementDisplayList(page)
      .then((response) => {
        if (response.length < itemPerPage) setLoadMore(false)

        setAnnouncementDisplayList(announcementDisplayList.concat(response))
      })
      .catch((error) => {
        ErrorHandler(error)
      })
      .finally(() => {
        setIsLoading(false)
        setPage(page + 1)
      })
  }

  const handleShowMore = () => {
    setIsLoading(true)
    GetNotificationList(notifyPage + 1)
      .then((response) => {
        setNotificationList(notificationList.concat(response.NotificationList))
        setShowMore(response.ShowMore)
        setUnreadNotificationCount(response.UnreadNotificationCount)
        Bus.emit(EVENT_EMITTER.NOTIFICATION.UNREAD_NOTIFICATION.UNREAD_NOTIFICATION_COUNT, response.UnreadNotificationCount)
      })
      .catch((error) => {
        ErrorHandler(error)
      })
      .finally(() => {
        setIsLoading(false)
        setNotifyPage(notifyPage + 1)
      })
  }

  const checkAndReset = (a: AnnouncementModel) => {
    if (checked) saveCookie(a)

    setActiveList(activeList.filter((ID) => ID != a.AnnouncementId))
    setIsChecked(false)
  }

  const popUpModal = (announcementID: ID) => {
    let selectedShowAnnouncement = announcementList.find((announcement) => announcement.AnnouncementId == announcementID)

    return (
      <>
        {selectedShowAnnouncement != undefined && (
          <Modal
            size='lg'
            show={true}
            centered={true}
            scrollable={true}
            onHide={() => {
              //check whether user ticked the checkbox
              if (selectedShowAnnouncement != undefined) checkAndReset(selectedShowAnnouncement)
              //if yes set cookie
              // setActiveList(activeList.filter((ID=>ID!=a.AnnouncementId)))
            }}
            key={selectedShowAnnouncement.AnnouncementId}
          >
            <Modal.Header closeButton={true} className='border-bottom-0 px-10 pt-10'>
              <Modal.Title>
                <div className='d-flex flex-column gap-2'>
                  <span className='text-primary'>{selectedShowAnnouncement.Title}</span>
                  <span className='d-block lh-1 fs-6 fw-normal text-muted'>
                    Published on {selectedShowAnnouncement.PublishingDate && moment(selectedShowAnnouncement.PublishingDate).format('DD MMM YYYY')}
                  </span>
                </div>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className='px-10 py-0 min-h-150px'>
              <div dangerouslySetInnerHTML={{__html: selectedShowAnnouncement?.Body ?? ''}}></div>
            </Modal.Body>

            <Modal.Footer className='d-flex flex-start border-top-0 px-10 pb-10'>
              <input
                className='form-check-input'
                type='checkbox'
                defaultChecked={checked}
                onChange={(e) => {
                  setIsChecked(true)
                  // saveCookie(a)
                }}
              />
              <span>Don't Show Again</span>
            </Modal.Footer>
          </Modal>
        )}
      </>
    )
  }

  const handleNotificationOnClick = (item: NotificationModel) => {
    if (item.MarkRead == true) {
      navigate(item.ActionPath)
    } else if (item.MarkRead == false) {
      navigate(item.ActionPath)

      setIsNotifyLoading(true)
      MarkAsRead(item.Id)
        .then((response) => {
          setNotificationList(
            notificationList.map((notification) => {
              if (notification.Id == item.Id) {
                notification.MarkRead = true
              }
              return notification
            })
          )
          var latestUnreadCount = unreadNotificationCount - 1
          setUnreadNotificationCount(latestUnreadCount)
          Bus.emit(EVENT_EMITTER.NOTIFICATION.UNREAD_NOTIFICATION.UNREAD_NOTIFICATION_COUNT, latestUnreadCount)
        })
        .catch((error) => {
          ErrorHandler(error)
        })
        .finally(() => {
          setIsNotifyLoading(false)
        })
    }
  }
  //#endregion

  //#region useEffect()
  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if (activeList.length > 0) setSelectedActiveAnnouncementID(activeList[0])
    else setSelectedActiveAnnouncementID(0)
  }, [activeList])

  useEffect(() => {
    if (state?.isFromLogin && announcementList) {
      const newList = announcementList.map((item) => {
        return item.AnnouncementId
      })

      setActiveList(newList.filter((announcementID) => !cookies[`AnnouncementId_${currentUser?.id}`]?.includes(announcementID)))
    }
  }, [state, announcementList])

  useEffect(() => {
    if (refreshInterval > 0) {
      const interval = setInterval(() => {
        _GetNotificationList()
      }, refreshInterval)
      return () => clearInterval(interval)
    }
  }, [refreshInterval])
  //#endregion

  //#region Asynchoronous function
  async function init() {
    await _GetAnnouncementList()
    await _GetNotificationList()
  }

  async function _GetAnnouncementList() {
    setIsLoading(true)
    GetAnnouncementList()
      .then((response) => {
        setItemPerPage(response.ItemPerPage)
        setAnnouncementDisplayList(response.AnnouncementDisplayList)
        if (response.AnnouncementDisplayList.length < itemPerPage) setLoadMore(false)

        setAnnouncementList(response.ActiveAnnouncementList)
      })
      .catch((error) => {
        ErrorHandler(error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  async function _GetNotificationList() {
    setIsNotifyLoading(true)
    GetNotificationList(notifyPage)
      .then((response) => {
        setNotificationList(response.NotificationList)
        setShowMore(response.ShowMore)
        setUnreadNotificationCount(response.UnreadNotificationCount)
        setRefreshInterval(response.RefreshInterval)
        Bus.emit(EVENT_EMITTER.NOTIFICATION.UNREAD_NOTIFICATION.UNREAD_NOTIFICATION_COUNT, response.UnreadNotificationCount)
      })
      .catch((error) => {
        ErrorHandler(error)
      })
      .finally(() => {
        setIsNotifyLoading(false)
      })
  }
  //#endregion

  return (
    <>
      {selectedActiveAnnouncementID != 0 && popUpModal(selectedActiveAnnouncementID)}

      {isOpenModal && (
        <Modal
          size='lg'
          show={isOpenModal}
          centered={true}
          scrollable={true}
          onHide={() => {
            setIsOpenModal(false)
          }}
        >
          <Modal.Header closeButton={true} className='border-bottom-0 px-10 pt-10'>
            <Modal.Title>
              <div className='d-flex flex-column gap-2 mt-2 mb-2'>
                <span className='text-primary'>{selectedAnnouncement?.Title}</span>
                <span className='d-block lh-1 fs-6 fw-normal text-muted'>
                  Published on {selectedAnnouncement?.PublishingDate && moment(selectedAnnouncement?.PublishingDate).format('DD MMM YYYY')}
                  {(selectedAnnouncement?.ExpiryDate != undefined || selectedAnnouncement?.ExpiryDate != '') &&
                    !moment(selectedAnnouncement?.ExpiryDate).isAfter(today) && (
                      <span className='fs-6 fw-normal'>
                        <Iconize biIcon='bi bi-dot' position='icon-only' />
                        Expired
                      </span>
                    )}
                </span>
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className='px-10 py-0 mb-10 min-h-150px'>
            <div dangerouslySetInnerHTML={{__html: selectedAnnouncement?.Body ?? ''}}></div>
          </Modal.Body>
        </Modal>
      )}

      <div className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px' data-kt-menu='true'>
        <div
          className='d-flex flex-column bgi-no-repeat rounded-top'
          style={{backgroundImage: `url('${toAbsoluteUrl('/media/misc/pattern-1.jpg')}')`}}
        >
          <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9 mt-10'>
            <li className='nav-item'>
              <a className='nav-link text-white opacity-75 opacity-state-100 pb-4 active' data-bs-toggle='tab' href='#announcement-menu'>
                Announcements
              </a>
            </li>

            <li className='nav-item'>
              <a className='nav-link text-white opacity-75 opacity-state-100 pb-4' data-bs-toggle='tab' href='#notification-menu'>
                Notifications
                {/* <Badge className='ms-2 bg-danger'>{(notificationList)?notificationList.filter(item=>item.MarkRead == false).length:''}</Badge> */}
                {unreadNotificationCount >= 1 && <Badge className='ms-2 bg-danger'>{unreadNotificationCount}</Badge>}
              </a>
            </li>
          </ul>
        </div>

        <div className='tab-content'>
          <div className='tab-pane fade show active' id='announcement-menu' role='tabpanel'>
            <div
              className={clsx('d-flex flex-column scroll-y p-5', {
                'h-350px': loadMore,
                'h-400px': !loadMore,
              })}
            >
              <Loading show={isLoading} type='spinner'></Loading>

              {announcementDisplayList?.length == 0 && (
                <Placeholderize type='secondary' faIcon={GetModuleIcon(Module.Announcements)} title='No Announcement' subtitle='' description={''} />
              )}

              {announcementDisplayList?.map((item, index) => (
                <div
                  key={`${item.AnnouncementId}`}
                  className='d-flex py-4 pt-1 pb-1 gap-4'
                  role='button'
                  onClick={(e) => {
                    e.preventDefault()
                    setIsOpenModal(true)
                    setSelectedAnnouncement(item)
                  }}
                >
                  <div className='symbol symbol-35px d-flex align-items-center'>
                    <span
                      className={
                        'symbol-label ' +
                        `bg-light-${
                          (item.ExpiryDate != undefined || item.ExpiryDate != '') && moment(item.ExpiryDate).isAfter(today)
                            ? GetModuleColor(Module.Announcements)
                            : 'muted'
                        }`
                      }
                    >
                      <Iconize
                        faIcon={`fs-1 ${GetModuleIcon(Module.Announcements)}`}
                        color={
                          (item.ExpiryDate != undefined || item.ExpiryDate != '') && moment(item.ExpiryDate).isAfter(today)
                            ? GetModuleColor(Module.Announcements)
                            : 'muted'
                        }
                        position='icon-only'
                      />
                    </span>
                  </div>

                  <div className='align-items-center text-truncate'>
                    <div className='mb-1 me-2'>
                      <div className='d-flex'>
                        <a
                          href='#'
                          className='fs-6 text-gray-800 text-hover-primary fw-bold  text-truncate'
                          onClick={(e) => {
                            e.preventDefault()
                            setIsOpenModal(true)
                            setSelectedAnnouncement(item)
                          }}
                          title={item.Title}
                        >
                          {item.Title}
                        </a>
                      </div>

                      <div className='text-gray-600 fs-7 text-truncate'>{item.Body.replace(/(<([^>]+)>)/gi, '')}</div>

                      <div className='text-gray-400 fs-8'>
                        <span>Published on {item.PublishingDate ? moment(item.PublishingDate).format('DD MMM YYYY') : ''}</span>
                        {(item.ExpiryDate != undefined || item.ExpiryDate != '') && !moment(item.ExpiryDate).isAfter(today) && (
                          <span>
                            <Iconize biIcon='bi bi-dot' position='icon-only' />
                            Expired
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {!loadMore && announcementDisplayList.length != 0 && (
                <div className='d-flex flex-column text-center text-gray-400 fs-7 gap-6 pt-6'>
                  <div className='separator separator-content w-100'>
                    <Iconize faIcon='fs-1 fas fa-check-circle' color='primary' />
                  </div>
                  <span>You have seen all the announcements.</span>
                </div>
              )}
            </div>

            {loadMore && (
              <div className='text-center border-top d-flex align-items-center flex-grow-1'>
                <span className='btn btn-color-gray-600 btn-active-color-primary w-100' onClick={() => handleLoadMore()}>
                  Load More <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
                </span>
              </div>
            )}
          </div>

          <div className='tab-pane fade' id='notification-menu' role='tabpanel'>
            <div
              className={clsx('d-flex flex-column scroll-y p-5', {
                'h-350px': showMore,
                'h-400px': !showMore,
              })}
            >
              <Loading show={isNotifyLoading} type='spinner'></Loading>

              {notificationList?.length == 0 && (
                <Placeholderize type='secondary' biIcon='bi-bell' title='No Notifications' subtitle='' description={''} />
              )}

              {notificationList?.map((item, index) => (
                <div
                  key={`${item.Id}`}
                  className='d-flex py-4 pt-1 pb-1 gap-4'
                  role='button'
                  onClick={() => {
                    handleNotificationOnClick(item)
                  }}
                >
                  <div className='symbol symbol-35px d-flex align-items-center'>
                    <span className={'symbol-label ' + `bg-light-${GetNotificationColor(item.IconColor)}`}>
                      {/* <Iconize faIcon={`fs-2 ${item.CustomIcon}`} color={GetNotificationColor(item.IconColor)} position='icon-only' /> */}
                      <div className='symbol symbol-25px symbol-fixed position-relative'>
                        {item.Type == NotificationType.ProgramSubmitted ? (
                          <img
                            style={{
                              backgroundImage: `url(${GetNotificationTypeIcon(item.Type)})`,
                              backgroundSize: '80%',
                              backgroundRepeat: 'no-repeat',
                              backgroundPosition: 'center',
                            }}
                          />
                        ) : (
                          <div
                            className={`image-input-wrapper symbol symbol-35px text-inverse-primary align-items-center fw-bolder d-flex flex-column justify-content-center`}
                            style={{fontSize: '2rem'}}
                          >
                            <Iconize
                              faIcon={`fs-2 ${GetNotificationTypeIcon(item.Type)}`}
                              color={GetNotificationColor(item.IconColor)}
                              position='icon-only'
                            />
                          </div>
                        )}
                      </div>
                    </span>
                  </div>

                  <div className='align-items-center text-truncate'>
                    <div className='mb-1 me-2'>
                      <div className='d-flex align-items-center gap-2'>
                        {!item.MarkRead && <Iconize faIcon='fs-9 fas fa-circle' color='danger' position='icon-only' />}
                        <a
                          href='#'
                          className='fs-6 text-gray-800 text-hover-primary fw-bold text-truncate'
                          onClick={(e) => {
                            e.preventDefault()
                            handleNotificationOnClick(item)
                          }}
                          title={item.Title}
                        >
                          {item.Title}
                        </a>
                      </div>

                      <div dangerouslySetInnerHTML={{__html: item.Message ?? ''}} className='text-gray-600 fs-7 text-wrap'></div>

                      <div className='text-gray-400'>
                        <span className='text-gray-400 fs-8'>
                          {(item.NotifyDateTime != undefined || item.NotifyDateTime != '') && moment(item.NotifyDateTime).startOf('minute').fromNow()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {!showMore && notificationList.length != 0 && (
                <div className='d-flex flex-column text-center text-gray-400 fs-7 gap-6 pt-6'>
                  <div className='separator separator-content w-100'>
                    <Iconize faIcon='fs-1 fas fa-check-circle' color='primary' />
                  </div>
                  <span>You have seen all the notifications.</span>
                </div>
              )}
            </div>

            {showMore && (
              <div className='text-center border-top d-flex align-items-center flex-grow-1'>
                <span className='btn btn-color-gray-600 btn-active-color-primary w-100' onClick={() => handleShowMore()}>
                  Load More <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export {HeaderNotificationsMenu}
